<inthraction-side-nav-drawer [menuOptions]="menuOptions"></inthraction-side-nav-drawer>
